<template>
  <div class="radar-chart">
    <slot></slot>
    <VChart
      style="width: 100%; height: 100%"
      :option="option"
      autoresize
    ></VChart>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  commonLang: String,
  chartData: Array,
});

const PAGE_TEXT = {
  'zh': {
    label1: '人口密度',
    label2: '区域等级',
    label3: '交通便利度',
    label4: '客群消费能力',
    label5: '商业成熟度',
  },
  'en': {
    label1: 'Population Density',
    label2: 'Region Level',
    label3: 'Transport Access',
    label4: 'Purchasing Power',
    label5: 'Business Maturity',
  }
};

const option = computed(() => {
  if (!props.chartData || !props.chartData.length) return {};
  return {
        radar: {
          // shape: 'circle',
          indicator: [
            {
              text: PAGE_TEXT[props.commonLang].label1,
              max: 10,
              value: props.chartData[0],
            },
            {
              text: PAGE_TEXT[props.commonLang].label2,
              max: 10,
              value: props.chartData[1],
            },
            {
              text: PAGE_TEXT[props.commonLang].label3,
              max: 10,
              value: props.chartData[2],
            },
            {
              text: PAGE_TEXT[props.commonLang].label4,
              max: 10,
              value: props.chartData[3],
            },
            {
              text: PAGE_TEXT[props.commonLang].label5,
              max: 10,
              value: props.chartData[4],
            },
          ],
          name: {
            formatter: function (params, i) {
              return "{yellow|" + i.text + "\n}{white| " + i.value + "}";
            },
            rich: {
              yellow: {
                color: "#000000",
                fontSize: 24,
                padding: [0, 0, 6, 0],
                fontWeight:600
              },
              white: {
                color: "#000000",
                fontSize: 24,
                align:'center',
                fontWeight:600
              },
            },
          },
        },
        series: [
          {
            name: "Budget vs spending",
            type: "radar",
            symbol: "circle",
            symbolSize:14,
            areaStyle: {
              color: "rgba(244,0,0,0.3)",
            },
            lineStyle: {
              color: "rgba(244,0,0,1)",
            },
            itemStyle:{
              color:'#FFFFFF',
              borderWidth:1,
              borderColor:"#F40000"
            },
            data: [
              {
                value: [
                  props.chartData[0],
                  props.chartData[1],
                  props.chartData[2],
                  props.chartData[3],
                  props.chartData[4],
                ],
                name: "Allocated Budget",
              },
            ],
          },
        ],
      };
});
</script>
<style lang="less">
.radar-chart {
  height: 100%;
  padding: 12px;
  position: relative;
}
</style>
